"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateThis = void 0;
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = tslib_1.__importStar(require("react"));
var universal_cookie_1 = tslib_1.__importDefault(require("universal-cookie"));
var SvgImage_1 = require("../../../components/SvgImage");
require("./styles.less");
var RateThis = /** @class */ (function (_super) {
    tslib_1.__extends(RateThis, _super);
    function RateThis(props) {
        var _this = _super.call(this, props) || this;
        _this.COOKIE_NAME = 'gs-rating';
        _this.eventProcessor = function (event) {
            _this.setState({
                pathName: _this.getPathName(event.detail),
                rateState: 'default',
                rating: 0,
            });
            setTimeout(function () { return _this.init(); }, 300);
        };
        _this.cookies = new universal_cookie_1.default();
        _this.state = {
            rateState: 'default',
            rating: 0,
            pathName: _this.getPathName(window.location.href),
        };
        return _this;
    }
    RateThis.prototype.getPathName = function (url) {
        var pathName = '';
        try {
            pathName = url ? new URL(url).pathname : '';
        }
        catch (err) {
            console.log('Error on parsing URL', url, err.message);
            var paths = url ? url.split('/content/') : [];
            pathName = paths && paths.length > 0 ? '/content/' + paths.pop() : '';
        }
        pathName = pathName.replace('.html', '') || '';
        return pathName;
    };
    RateThis.prototype.init = function () {
        var cookie = this.getCookie();
        var rateState = this.checkRateState(cookie);
        if (cookie.length === 2) {
            this.setState({
                rateState: rateState,
                rating: parseInt(cookie[0], 10),
            });
        }
    };
    RateThis.prototype.componentDidMount = function () {
        this.init();
        if (this.props.videoPage) {
            // @ts-ignore
            window.addEventListener('video-card-change', this.eventProcessor);
        }
    };
    RateThis.prototype.componentWillUnmount = function () {
        if (this.props.videoPage) {
            // @ts-ignore
            window.removeEventListener('video-card-change', this.eventProcessor);
        }
    };
    RateThis.prototype.checkRateState = function (cookie) {
        return this.checkCookie(cookie) ? 'success' : 'default';
    };
    RateThis.prototype.displayStars = function () {
        var _this = this;
        var stars = [1, 2, 3, 4, 5].map(function (item) {
            var className = ('star star-' + item) + (item <= _this.state.rating ? ' clicked' : '');
            return (React.createElement("div", { key: 'outer-star-' + item, onClick: function () { return _this.updateRating(item); } },
                React.createElement("div", { className: className, key: className })));
        });
        return (React.createElement("div", { className: 'stars' }, stars));
    };
    RateThis.prototype.setCookie = function (cookieName, cookieValue, pathName) {
        var time = new Date();
        // 30 days
        time.setTime(time.getTime() + (30 * 24 * 60 * 60 * 1000));
        // use root of green record to provide access though all site
        var path = window.location.pathname || '';
        var split = path.split('green-section-record');
        if (split && split.length === 2) {
            path = split[0] + 'green-section-record';
        }
        else {
            path = '/content/usga/home-page/course-care/green-section-record';
        }
        this.cookies.set(cookieName, cookieValue + '^^^' + pathName, {
            expires: time,
            path: path,
        });
    };
    RateThis.prototype.getCookie = function () {
        var name = this.getCookieName();
        var result = this.cookies.get(name) || '';
        // @ts-ignore
        return result.split('^^^');
    };
    RateThis.prototype.checkCookie = function (cookie) {
        if (cookie.length === 2) {
            return cookie[1] === this.state.pathName;
        }
        return false;
    };
    RateThis.prototype.getSubmitStyle = function () {
        var btnStyle = 'btn-submit';
        if (this.state.rateState === 'success') {
            btnStyle += ' success';
        }
        else if (this.state.rateState === 'clicked') {
            btnStyle += ' clicked';
        }
        return btnStyle;
    };
    RateThis.prototype.submitRating = function () {
        var _this = this;
        var cookie = this.getCookie();
        if (this.checkCookie(cookie)) {
            return;
        }
        if (this.state.rating >= 1 && this.state.rating <= 5) {
            // @ts-ignore
            var ratingUrl = window.globalSettings.feeds.ratingUrl ||
                '/bin/usga/green/rating';
            var data = {
                pagePath: this.state.pathName,
                userRating: this.state.rating,
            };
            // @ts-ignore
            this.props.globalStore.httpService.post(ratingUrl, data).then(function (response) {
                if (response.status === 200) {
                    _this.setState({
                        rateState: 'success',
                    });
                    _this.setCookie(_this.getCookieName(), _this.state.rating, _this.state.pathName);
                }
            });
        }
    };
    RateThis.prototype.getCookieName = function () {
        return this.COOKIE_NAME + '_*_' + this.state.pathName;
    };
    RateThis.prototype.updateRating = function (rate) {
        if (this.state.rateState !== 'success' && rate > 0 && rate <= 5) {
            var newRate = rate;
            var rateState = 'clicked';
            if (this.state.rating === rate) {
                newRate = 0;
                rateState = 'default';
            }
            this.setState({
                rating: newRate,
                rateState: rateState,
            });
        }
    };
    RateThis.prototype.render = function () {
        var _this = this;
        return (React.createElement("section", { className: 'm-rate-this ' + this.state.rateState },
            React.createElement("div", { className: 'main' },
                this.state.rateState === 'success' ?
                    React.createElement("div", { className: 'thumbs-up-image' },
                        React.createElement(SvgImage_1.SvgImage, { image: 'sprites.svg#thumbs-up' })) :
                    null,
                React.createElement("div", { className: 'title' }, this.state.rateState === 'success' ? 'Thank You' : this.props.title),
                React.createElement("div", { className: 'subtitle' }, this.state.rateState === 'success' ?
                    'Your feedback was successfully submitted' : 'Your opinion matters to us!'),
                this.displayStars(),
                React.createElement("button", { className: this.getSubmitStyle(), disabled: this.state.rateState === 'success' || this.state.rating < 1
                        || this.state.rating > 5, onClick: function () { return _this.submitRating(); } }, "SUBMIT"))));
    };
    RateThis = tslib_1.__decorate([
        mobx_react_1.inject('globalStore'),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], RateThis);
    return RateThis;
}(React.Component));
exports.RateThis = RateThis;
